import { FunctionComponent } from 'react';

type Props = JSX.IntrinsicElements['svg'];

export const IconChevronDown: FunctionComponent<Props> = props => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' {...props}>
    <path fill='#100D10' fillRule='evenodd' d='M7 10l5 5 5-5z' />
  </svg>
);
